import $ from "jquery";
import moment from "moment";
import vuwer from "@pressmedia/vuwer";
const { app } = window;

// [copyright]
vuwer.add("copyright", {
	selector: "#copyright",
	
	onReady($self) {
		if($self && app.config.copyright) {
			return this.setState("html", app.config.copyright);
		}
	},
	
	render($elm, state) {
		$elm = $("<p/>").addClass(this.name);
		if(state.html) {
			$elm.html( $.parseHTML(state.html) );
			
			const $toYear = $elm.find(".toyear");
			if($toYear.length) {
				const nowYear = ( app.now || moment() ).format("YYYY");
				const fromYear = $elm.find(".fromyear").text();
				if(fromYear === nowYear) {
					$toYear.remove();
				} else {
					$toYear.text(nowYear);
				}
			}
			
			return $elm;
		}
	}
});
